import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Who killed Amanda Palmer",
  "description": "",
  "published": "2008-09-09T00:00:00.000Z",
  "redirect_from": ["/blog/who-killed-amanda-palmer/swizec/73"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is why I love Amanda Palmer, just pre-ordered her album and got a very elaborate thank you over e-mail. Four pdf's and a stencil, it totally made my day so here's the first and most important pdf quoted for you:`}</p>
    <p>{`Dear You, Listener -`}<br parentName="p"></br>{`
`}{`It's Amanda.`}<br parentName="p"></br>{`
`}{`Thank you, so much, for buying this record.`}<br parentName="p"></br>{`
`}{`If you are downloading this file, it means that you know how to use a computer.`}<br parentName="p"></br>{`
`}{`If you know how to use a computer, you could have easily gotten this record for free from`}<br parentName="p"></br>{`
`}{`any of your friends.`}<br parentName="p"></br>{`
`}{`But instead, you bought it. For that, I am truly grateful.`}<br parentName="p"></br>{`
`}{`We are living in strange times for the record business.`}<br parentName="p"></br>{`
`}{`Recorded music has been perceived as not worth paying for for a while now, but it still`}<br parentName="p"></br>{`
`}{`costs money to record music.`}<br parentName="p"></br>{`
`}{`Moreover, a musician must have money to eat, pay rent, buy instruments, do coke off of`}<br parentName="p"></br>{`
`}{`strippersÊ¼ tits and all of the other things musicians must do to ï¬nd their muse.`}<br parentName="p"></br>{`
`}{`It's going to be an interesting few years, these next few, while the business expands and`}<br parentName="p"></br>{`
`}{`contracts and musicians experiment with new ways to actually make money off of their`}<br parentName="p"></br>{`
`}{`recorded music while more and more people buy computers and ï¬gure out that to PAY for`}<br parentName="p"></br>{`
`}{`music in a STORE is becoming rather ridiculous and redundant.`}<br parentName="p"></br>{`
`}{`MY dream about the future is that the artist/listener relationship will trump everything else,`}<br parentName="p"></br>{`
`}{`and that true fans and appreciators of artists will actively WANT to support them, will`}<br parentName="p"></br>{`
`}{`WANT to give them money, perhaps in a slightly different conï¬guration than we're used to.`}<br parentName="p"></br>{`
`}{`I'm trying to ï¬gure out creative ways to do that. Time was, famous painters and musicians`}<br parentName="p"></br>{`
`}{`had rich patrons and royalty who fed them and kept them kicking around because ART`}<br parentName="p"></br>{`
`}{`MADE LIFE BETTER AND MORE INTERESTING. Nowadays, with the power of the net, a`}<br parentName="p"></br>{`
`}{`mish-mashy assortment of people spanning the globe can be that patron, if it's wisely`}<br parentName="p"></br>{`
`}{`organized. Those people would be, ahem, YOU.`}<br parentName="p"></br>{`
`}{`For now, there are two simple, and very powerful, things you can do to help me`}<br parentName="p"></br>{`
`}{`out....above and beyond buying this record, above and beyond buying merchandise and`}<br parentName="p"></br>{`
`}{`concert tickets and books and all the other things I will try to entice you to buy: Stay in`}<br parentName="p"></br>{`
`}{`touch with me (make sure you're on the MySpace or mailing list - if you're not, please,`}<br parentName="p"></br>{`
`}{`please subscribe) and spread the word. Your recommendation about this record to a friend`}<br parentName="p"></br>{`
`}{`means WAY more than any fancy marketing me or my label can do.`}<br parentName="p"></br>{`
`}{`If you love it, share it. Really. Do.`}<br parentName="p"></br>{`
`}{`Long live the punk cabaret, comrades.`}<br parentName="p"></br>{`
`}{`XXXOOO`}<br parentName="p"></br>{`
`}{`amanda palmer`}<br parentName="p"></br>{`
`}{`P.S. As a token of appreciation, please enjoy some previews of photos and a story from`}<br parentName="p"></br>{`
`}{`Who Killed Amanda Palmer (the BOOK)...`}</p>
    <p>{`I mean ... how often is it that people actually thank you for buying their stuff these days?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      